module.exports = __webpack_public_path__ + "img/articleAlimentation.67c7c111.png";